// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kEyTS","crumb":"styles_crumb__hok_6","label":"styles_label__0cK4A","icon":"styles_icon__eFsLJ"};